const primaryColors = {
  red: '#fb8799' /* Salmon pink */,
  purple: '#b193f3' /* Bright lavender */,
  blue: '#88c3fc' /* Maya blue */,
  yellow: '#fbd769' /* Jonquil */,
  green: '#87fcc2',
}

const greyColors = {
  white: '#fff' /* White */,
  whiteSmoke: '#f6f5fa' /* White smoke */,
  roseQuartz: '#a39db0' /* Rose quartz */,
  // dimGray: '#665f77' /* Dim gray */,
  // TODO: (2) Apply color adjustments to sketch file
  dimGray: '#5e5477' /* Dim gray */,
}

export default {
  fontSizes: [
    '1.125rem', // 18px
    '1.8125rem', // 29px
    '2.875rem', // 46px
    '4.625rem', // 74px
    '7.375rem', // 118
    '11.8125rem', // 189px
  ],
  colors: {
    primary: {
      ...primaryColors,
    },
    branch: {
      K: primaryColors.red,
      P: primaryColors.blue,
      Z: primaryColors.purple,
      I: primaryColors.green,
    },
    greys: {
      light: greyColors.white,
      mediumLight: greyColors.whiteSmoke,
      mediumDark: greyColors.roseQuartz,
      dark: greyColors.dimGray,
    },
    text: {
      inverse: greyColors.white,
      normal: greyColors.dimGray,
    },
  },
}
